module.exports = __webpack_public_path__ + "img/14. Кабинет мануальной терапии.49e7698b.jpg";